import React from 'react';
import { Select, Input, Button } from 'antd';
import { BsSearch } from 'react-icons/bs';
import { TasksTable } from './tasks-table';
import { useTasksTab } from './use-tasks-tab';
import styles from '../../styles.module.scss';

const { Option } = Select;

type TasksTabProps = {
    dagId: string;
    refreshKey: number;
};

/*
 * DAG detail's Tasks tab — client-side filtered/paginated list of task definitions
 */
export function TasksTab({ refreshKey, dagId }: TasksTabProps) {
    const {
        isLoading,
        search,
        setSearch,
        operatorFilter,
        setOperatorFilter,
        triggerRuleFilter,
        setTriggerRuleFilter,
        retriesFilter,
        setRetriesFilter,
        mappedFilter,
        setMappedFilter,
        operatorOptions,
        triggerRuleOptions,
        retriesOptions,
        mappedFilterOptions,
        hasActiveFilters,
        handleClearFilters,
        pagedTasks,
        filteredCount,
        totalTasks,
        page,
        setPage,
        totalPages,
        handleTaskClick,
    } = useTasksTab(dagId, refreshKey);

    return (
        <div className={styles.card}>
            <div className={styles.filterRow}>
                <h3 style={{ margin: 0, color: '#fff', fontSize: 14, fontWeight: 700, letterSpacing: 0.25 }}>{`Tasks${filteredCount !== totalTasks ? ` (${filteredCount} of ${totalTasks})` : ` (${totalTasks})`}`}</h3>
                {hasActiveFilters && (
                    <Button type="link" onClick={handleClearFilters}>
                        Clear filters
                    </Button>
                )}
            </div>
            <div className={styles.filterRow}>
                <Input prefix={<BsSearch />} placeholder="Search tasks" value={search} onChange={(e) => setSearch(e.target.value)} allowClear style={{ width: 200 }} />
                <Select value={operatorFilter || undefined} placeholder="Operator" allowClear style={{ width: 160 }} onChange={(value) => setOperatorFilter(value ?? '')}>
                    {operatorOptions.map((option) => (
                        <Option key={option} value={option}>
                            {option}
                        </Option>
                    ))}
                </Select>
                <Select value={triggerRuleFilter || undefined} placeholder="Trigger Rule" allowClear style={{ width: 160 }} onChange={(value) => setTriggerRuleFilter(value ?? '')}>
                    {triggerRuleOptions.map((option) => (
                        <Option key={option} value={option}>
                            {(option ?? '').replace(/_/g, ' ')}
                        </Option>
                    ))}
                </Select>
                <Select value={retriesFilter || undefined} placeholder="Retries" allowClear style={{ width: 100 }} onChange={(value) => setRetriesFilter(value ?? '')}>
                    {retriesOptions.map((option) => (
                        <Option key={String(option)} value={String(option)}>
                            {option}
                        </Option>
                    ))}
                </Select>
                <Select value={mappedFilter || undefined} placeholder="Mapped" style={{ width: 120 }} onChange={(value) => setMappedFilter(value ?? '')}>
                    {mappedFilterOptions.map((option) => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
            </div>
            <TasksTable tasks={pagedTasks} isLoading={isLoading} onTaskClick={handleTaskClick} />
            <div className={styles.paginationRow} style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#666a8d', fontSize: 13 }}>{`Showing ${pagedTasks.length} of ${filteredCount} tasks`}</span>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <Button size="small" disabled={page <= 1} onClick={() => setPage(page - 1)}>
                        Prev
                    </Button>
                    <span style={{ color: '#666a8d', fontSize: 13 }}>{`Page ${page} of ${totalPages}`}</span>
                    <Button size="small" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>
                        Next
                    </Button>
                </div>
            </div>
        </div>
    );
}
